var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title:
          _vm.$t("mandate.bank_selection_title") || "Sélection de votre banque",
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-start",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("back-button", {
                        staticClass: "btnFilter_2",
                        attrs: { returnUrl: "/modechoice" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mx-auto", attrs: { cols: "12", md: "6" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.search,
                            expression: "search",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "filter-item-content w-100",
                        staticStyle: {
                          padding: "0.35rem 0.5rem 0.35rem 0.7rem",
                        },
                        attrs: {
                          placeholder:
                            _vm.$t("mandate.search_bank") ||
                            "Rechercher votre banque",
                        },
                        domProps: { value: _vm.search },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search = $event.target.value.trim()
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                _vm._l(_vm.filteredBanks, function (bank) {
                  return _c(
                    "b-col",
                    {
                      key: bank.id,
                      staticClass: "mb-3",
                      attrs: { cols: "12", sm: "6", md: "4", lg: "3" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "bank-card",
                          on: {
                            click: function ($event) {
                              return _vm.selectBank(bank)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "bank-logo-placeholder" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(bank.name.charAt(0)) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "bank-name" }, [
                            _vm._v(_vm._s(bank.name)),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.filteredBanks.length === 0
                ? _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex justify-content-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c("span", { staticClass: "noResult" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("common.no_result") ||
                                  "Aucune banque trouvée"
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }